var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 24.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 24.5,
    stroke: "#E7EDE8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.25 30.5613V23.076C33.25 19.0138 30.1121 15.6555 26.1659 14.7557V14.1708C26.1659 13.5854 25.7113 12.9993 25.0515 13C24.3917 13.0007 23.8349 13.4533 23.7327 14.1708V14.7557C19.8002 15.6555 16.75 19.0005 16.75 23.076V30.5613L14 32.3383V33.6615H36V32.3383L33.25 30.5613ZM25 37C26.5125 37 27.75 36.4402 27.75 34.9847H22.25C22.25 36.4402 23.4875 37 25 37ZM18.8664 31.7316H31.0323V23.076C31.0323 19.7944 28.4238 17.1143 25 17.1143C21.5763 17.1143 18.8664 19.7944 18.8664 23.076V31.7316Z",
    fill: "#00703E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.c729772cc4e81277ab1ce71d29fc231b.svg";
export { ForwardRef as ReactComponent };